import {
  Avatar,
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogProps,
  Divider,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useState } from 'react';  
import { FormattedMessage } from 'react-intl';
import { useWalletActivate } from '../../hooks/misc';
import { AppDialogTitle } from '../AppDialogTitle'; 
const metamaskIcon = '../../assets/images/metamask-fox.svg'; 
const walletConnectIcon = '../../assets/images/walletconnect-circle-blue.svg';
const coinbaseWalletIcon   = '../../img/coinbase-wallet-logo.png'; 

interface Props {
  dialogProps: DialogProps;
}

function ConnectWalletDialog({ dialogProps }: Props) {
  const { onClose } = dialogProps;

  const walletActivate = useWalletActivate();

  const [connectorName, setConnectorName] = useState<string>();

  const handelClose = () => {
    onClose!({}, 'backdropClick');
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));  

  const handleActivateWallet = async (connectorName: string) => {
    console.log('handleActivateWallet useMutation',connectorName);
    setConnectorName(connectorName);
    try {
      await walletActivate.mutateAsync({ connectorName });
      handelClose();
      setConnectorName(undefined);
    } catch (error) {
      console.log('handleActivateWallet useMutation',error);
    }
  /*   if (connectorName === 'metamask') {
      console.log('handleActivateWallet metamask',connectorName);
      // return await connect(connectors['metaMask'],80002); 
      //return await metaMask.activate();
    } else if (connectorName === 'walletConnect') {
      //return await walletConnect.activate();
      console.log('handleActivateWallet walletConnect',connectorName);
     return await connect(connectors['walletConnect'],80002);
    } */ 
  };

  return (
    <Dialog {...dialogProps} onClose={handelClose}>
      <AppDialogTitle
        title={
          <FormattedMessage
            id="connect.your.wallet"
            defaultMessage={'Connect your Wallet'}
            description={'Connect wallet message'}
          />
        }
        onClose={handelClose}
      />
      <Divider />
      <DialogContent sx={{ padding: 0 }}>
        <List disablePadding> 
            <ListItemButton
              divider
              disabled={
                walletActivate.isLoading && connectorName === 'metaMask'
              }
              onClick={() => handleActivateWallet('metaMask')}
            >
              <ListItemIcon>
                <Box
                  sx={{
                    width: (theme) => theme.spacing(8),
                    display: 'flex',
                    alignItems: 'center',
                    alignContent: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {walletActivate.isLoading && connectorName === 'metaMask' ? (
                    <CircularProgress
                      color="primary"
                      sx={{ fontSize: (theme) => theme.spacing(4) }}
                    />
                  ) : (
                    <Avatar
                      src={metamaskIcon}
                      sx={(theme) => ({
                        background: theme.palette.action.hover,
                        padding: theme.spacing(1),
                        width: theme.spacing(5),
                        height: theme.spacing(5),
                      })}
                      alt={'Metamask'}
                    />
                  )}
                </Box>
              </ListItemIcon>
              <ListItemText primary="MetaMask" />
            </ListItemButton> 
          <ListItemButton
            disabled={
              walletActivate.isLoading && connectorName === 'walletConnect'
            }
            onClick={() => handleActivateWallet('walletConnect')}
          >
            <ListItemIcon>
              <Box
                sx={{
                  width: (theme) => theme.spacing(8),
                  display: 'flex',
                  alignItems: 'center',
                  alignContent: 'center',
                  justifyContent: 'center',
                }}
              >
                <Avatar
                  src={walletConnectIcon}
                  sx={(theme) => ({
                    background: theme.palette.action.hover,
                    padding: theme.spacing(1),
                    width: theme.spacing(5),
                    height: theme.spacing(5),
                  })}
                />
              </Box>
            </ListItemIcon>
            <ListItemText primary="WalletConnect" />
          </ListItemButton>
          <ListItemButton
            disabled={
              walletActivate.isLoading && connectorName === 'coinbaseWallet'
            }
            onClick={() => handleActivateWallet('coinbaseWallet')}
          >
          <ListItemIcon>
              <Box
                sx={{
                  width: (theme) => theme.spacing(8),
                  display: 'flex',
                  alignItems: 'center',
                  alignContent: 'center',
                  justifyContent: 'center',
                }}
              >
                <Avatar
                  src={coinbaseWalletIcon}
                  sx={(theme) => ({
                    background: theme.palette.action.hover,
                    padding: theme.spacing(1),
                    width: theme.spacing(5),
                    height: theme.spacing(5),
                  })}
                />
              </Box>
            </ListItemIcon>
            <ListItemText primary="coinbaseWallet" />
          </ListItemButton>
        </List>
      </DialogContent>
    </Dialog>
  );
}

export default ConnectWalletDialog;
